<template>
  <v-container fluid>
    <v-row>
      <v-col cols="12" md="12" lg="4">
        <v-card
          class="fill-height d-flex flex-column"
          outlined
        >
          <v-card-title>
            {{ title }}
            <v-spacer />
            <v-chip v-if="items.length !== 0"
              color="#244EA2" dark
            >
              {{ items.length }}
            </v-chip>
          </v-card-title>
          <v-divider />
          <v-card-text>
            <v-form ref="form">
              <v-text-field
                v-model="params.nome"
                :rules = "[rules.counter]"
                label="Nome"
                counter
                maxlength="50"
              />
              <v-autocomplete label="Município"
                v-model="params.municipio"
                :items="municipios"
                item-text="nome" item-value="codibge"
                clearable
              />
              <v-autocomplete
                label="Orgão"
                v-model="params.orgao"
                :items="options.orgao"
                item-text="nome" item-value="codigo"
                clearable
                color="#244EA2"
                item-color="#244EA2"
              />
              <v-autocomplete
                label="Tipo de Patrimônio"
                v-model="params.tipo"
                :items="options.tipoPatrimonio"
                item-text="descricao" item-value="codigo"
                clearable
                @change="getClassificacao()"
                color="#244EA2"
                item-color="#244EA2"
              />
              <v-autocomplete
                label="Classificação"
                v-model="params.classificacao"
                :items="options.classificacao"
                item-text="nome" item-value="codigo"
                clearable chips deletable-chips
                hide-details
                :disabled="options.classificacao.length === 0"
                color="#244EA2"
                item-color="#244EA2"
              />
            </v-form>
          </v-card-text>
          <v-container fluid pa-0 ma-0>
            <v-row justify="center" no-gutters>
              <v-col cols="12" sm="6" md="6" lg="8">
                <canvas id="myChart" style="max-height: 300px"></canvas>
              </v-col>
            </v-row>
          </v-container>

          <v-spacer></v-spacer>
          <v-card-actions>
            <v-spacer />
            <v-btn @click="reset()">Limpar</v-btn>
            <v-btn @click="addLayer()" color="#244EA2" dark>Pesquisar</v-btn>
          </v-card-actions>
        </v-card>
      </v-col>

      <v-col cols="12" lg="8">
        <v-card
          :loading="loading"
          outlined
        >
          <div :id="mapid" style="height: 475px;"></div>
        </v-card>
      </v-col>

      <v-col cols="12">
        <v-data-iterator
          :items="items"
          :items-per-page="12"
        >
          <!--template v-slot:header>
            <v-container fluid pa-0>
              <v-row justify="end">
                <v-col cols="12" lg="4">
                  <v-text-field
                    v-model="search"
                    label="Pesquisar"
                    prepend-inner-icon="mdi-magnify"
                    clearable
                    flat
                    hide-details
                    solo
                  />
                </v-col>
              </v-row>
            </v-container>
          </template-->
          <template v-slot:default="props">
            <v-row>
              <v-col
                v-for="(item, i) in props.items"
                :key="i"
                cols="12"
                md="4"
              >
                <v-card class="fill-height d-flex flex-column" outlined>
                  <v-card-text>
                    <p>{{ item.tipoPatrimonio }}</p>
                    <p><b>{{ item.nome }}</b></p>
                    <p>{{ item.descricao && item.descricao.length > 200 ? item.descricao.substr(0, 200) + '...' : item.descricao }}</p>
                  </v-card-text>
                  <v-spacer></v-spacer>
                  <v-card-actions>
                    <v-spacer></v-spacer>
                    <v-tooltip bottom>
                      <template v-slot:activator="{ on, attrs }">
                        <v-btn
                          :to="'/patrimonio/' + item.codigo"
                          fab small outlined
                          v-bind="attrs"
                          v-on="on"
                        >
                          <v-icon>mdi-open-in-new</v-icon>
                        </v-btn>
                      </template>
                      <span>Mais informações</span>
                    </v-tooltip>
                  </v-card-actions>
                </v-card>
              </v-col>
            </v-row>
          </template>
        </v-data-iterator>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
import wms from 'leaflet.wms'

// import axios from 'axios'
import Chart from 'chart.js'
import * as L from 'leaflet'
import * as esri from 'esri-leaflet'
import { groupBy, uniqueId } from 'lodash'

import api from '@/api/vue-exemplo'

import { getBounds } from '@/domain/library'

export default {
  name: 'Patrimonios',
  data: () => ({
    mapid: null,
    headers: [
      { text: 'Nome', value: 'nome', width: '65%' },
      { text: 'Tipo', value: 'tipoPatrimonio', width: '30%' },
      { text: '', value: 'data-table-expand', width: '5%' }
    ],
    items: [],
    expanded: [],
    loading: false,
    search: null,
    title: 'Patrimônio Cultural',
    rules: {
      counter: value => value.length >= 3 || 'No mínimo 3 caracteres'
    },

    options: {
      tipoPatrimonio: [],
      classificacao: [],
      orgao: []
    },
    params: {
      tipo: null,
      classificacao: null,
      orgao: null,
      municipio: null,
      nome: ''
    },
    template: `
      <h2><strong>{nome}</strong></h2><br>
    `,

    labels: [],
    data: [],

    localizacoes: []
  }),
  beforeRouteEnter (to, from, next) {
    next(vm => {
      vm.onResize()
    })
  },
  computed: {
    municipios () {
      return this.$store.getters.municipios
    }
  },
  mounted () {
    this.mapid = uniqueId()
    this.$nextTick(() => {
      this.map = L.map(this.mapid)
      this.map.fitBounds(getBounds())

      var baseLayers = {
        'ESRI Gray': esri.basemapLayer('Gray'),
        'ESRI Imagery': esri.basemapLayer('Imagery'),
        'ESRI Topographic': esri.basemapLayer('Topographic').addTo(this.map),
        'OpenStreetMap': L.tileLayer('https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png', {
          attribution: '&copy; <a href="https://www.openstreetmap.org/copyright">OpenStreetMap</a> contributors'
        })
      }

      var Source = wms.Source.extend({
        parseFeatureInfo: function (result) { // url
          var json = JSON.parse(result)
          if (json.features.length === 0) return 'Sem dados disponíveis'

          var properties = json.features[0].properties
          var html = '<table style="border: 2px">'
          for (var property in properties) {
            html += '<tr><td style="padding-top: 4px; padding-bottom: 4px; padding-right: 4px"><b>' + property + '</b></td>'
            html += '<td style="padding-top: 4px; padding-bottom: 4px">' + properties[property] + '</td></tr>'
          }
          html += '</table>'
          return html
        }
      })

      var source = new Source(process.env.VUE_APP_GEOSERVER, {
        format: 'image/png',
        info_format: 'application/json',
        transparent: true,
        tiled: true
      })

      /*
      L.tileLayer.wms(process.env.VUE_APP_GEOSERVER, {
        format: 'image/png',
        layers: 'seec:area_tombamento',
        transparent: true,
        tiled: true
      }).addTo(this.map)
      */

      var overlays = {
        'Tombamento da Serra do Mar': source.getLayer('seec:area_tombamento').addTo(this.map),
        'Patrimônio Cultural': source.getLayer('seec:patrimonio').addTo(this.map)
      }

      L.control.layers(baseLayers, overlays).addTo(this.map)

      L.control.defaultExtent({
        title: 'Visão Inicial'
      }).addTo(this.map)

      /*L.Control.geocoder({
        position: "topleft",
        placeholder: "Pesquisar..."
      }).addTo(this.map)*/

      L.control.fullscreen({
        title: {
          'false': 'Ver em tela inteira',
          'true': 'Sair da tela inteira'
        }
      }).addTo(this.map)

      this.cluster = L.markerClusterGroup()
      this.map.addLayer(this.cluster)

      this.addLayer()
    })

    this.$store.dispatch('getMunicipios')

    this.getTipoPatrimonio()
    this.getClassificacao()
    this.getOrgao()

    this.icon = new L.Icon({
      iconUrl: require('@/assets/marker-icon-blue.png'),
      shadowUrl: require('@/assets/marker-shadow.png'),
      iconSize: [25, 41],
      iconAnchor: [12, 41],
      popupAnchor: [1, -34],
      shadowSize: [41, 41]
    })

    this.addChart()
  },
  methods: {
    reset () {
      this.$refs.form.reset()
      this.getClassificacao()
      this.addLayer()
    },
    getTipoPatrimonio () {
      api.getTipoPatrimonio()
        .then(response => {
          this.options.tipoPatrimonio = response.data
        })
        .catch(error => {
          console.log(error)
        })
    },
    getOrgao() {
      api.getOrgao()
        .then(response => {
          this.options.orgao = response.data
        })
        .catch(error => {
          console.log(error)
        })
    },
    getClassificacao () {
      api.getClassificacao(this.params)
        .then(response => {
          this.options.classificacao = response.data
        })
        .catch(error => {
          console.log(error)
        })
    },
    getLocalizacoes () {
      api.getLocalizacoes({
        tipo: this.params.tipo,
        classificacao: this.params.classificacao,
        orgao: this.params.orgao,
        municipio: this.params.municipio,
        nome: this.params.nome
      })
        .then(response => {
          this.localizacoes = response.data

          var markers = []
          this.localizacoes.forEach(localizacao => {
            var lng = localizacao.longitude
            var lat = localizacao.latitude
            if (lng && lat) {
              lng = L.Util.formatNum(lng, 6)
              lat = L.Util.formatNum(lat, 6)
              if(lng < 180 && lng > -180 && lat < 90 && lat > -90) {

                var popup = '<p>' + localizacao.orgao + '</p>'

                popup += '<div style="text-align: center"><h2><strong>' + localizacao.nome + '</strong></h2>'
              
                if (localizacao.descricao) {
                  popup += '<div style="max-height: 100px; overflow:auto; text-align: justify; text-justify: inter-word;">'
                    + localizacao.descricao
                    + '</div>'
                }

                if (localizacao.codigoImagem) {
                  popup += '<img height="100" src="'
                    + this.enderecoImagem(localizacao.codigoImagem)
                    + '"/></div>'
                }
                
                popup += '<p><a href="'
                  + 'https://www.google.com/maps/search/?api=1&query='
                  + encodeURIComponent(this.enderecoCompleto(localizacao))
                  + '" target="_blank">'
                  + this.enderecoCompleto(localizacao)
                  + '</a></p>'

                popup += '<p><a href="'
                  + 'https://www.google.com/maps/search/?api=1&query='
                  + encodeURIComponent(lat + ',' + lng)
                  + '" target="_blank">'
                  + lng + ', ' + lat
                  + '</a></p>'

                popup += '<p>SAIBA MAIS: <a href="'
                  + 'https://www.patrimoniocultural.pr.gov.br"'
                  + ' target="_blank">'
                  + 'https://www.patrimoniocultural.pr.gov.br'
                  + '</a></p>'

                var marker = L.marker(new L.LatLng(lat, lng), {
                  icon: this.icon
                })
                marker.bindPopup(popup)
                marker.bindTooltip(localizacao.nome + '')
                markers.push(marker)
              }
            }
          })

          this.cluster.addLayers(markers)

          if (this.cluster.getBounds().isValid()) {
            this.map.fitBounds(this.cluster.getBounds())
          } else {
            this.map.fitBounds(getBounds())
          }
        })
        .catch(error => {
          console.log(error)
        })
    },
    enderecoImagem (codigo) {
      return process.env.VUE_APP_SIC_CULTURA
        + '/imagem.php?tipoimagem=11&codigo='
        + codigo
    },
    addLayer () {
      this.removeLayer()

      this.getLocalizacoes()

      this.loading = true
      this.$store.commit('setLoading', true)

      api.getPatrimonio(this.params)
        .then(response => {
          this.items = response.data
          this.updateChart(this.items)
        })
        .catch(error => {
          console.log(error)
        })
        .finally(() => {
          this.loading = false
          this.$store.commit('setLoading', false)
        })
    },
    removeLayer () {
      if (this.cluster) {
        this.cluster.clearLayers()
      }
    },
    onResize () {
      if (this.map) {
        this.map.invalidateSize()
      }
    },
    enderecoCompleto (localizacao) {
      let endereco = localizacao.endereco
        + ', ' + localizacao.numero
        + ', ' + localizacao.bairro

      if (localizacao.municipio) {
        endereco += ", " + localizacao.municipio.nome
      }
      if (localizacao.cep) {
        endereco += ", " + localizacao.cep.replace(/^(\d{5})(\d{3}).*/, '$1-$2')
      }

      return endereco
    },
    addChart () {
      var ctx = document.getElementById('myChart').getContext('2d')

      this.chart = new Chart(ctx, {
        type: 'doughnut',
        data: {
          labels: this.labels,
          datasets: [{
            label: 'My First Dataset',
            data: this.data,
            backgroundColor: [
              'rgb(255, 99, 132)',
              'rgb(54, 162, 235)',
              'rgb(255, 205, 86)'
            ],
            hoverOffset: 4
          }]
        },
        options: {
          legend: {
            position: 'right'
          }
        }
      })
    },
    updateChart (items) {
      var data = groupBy(items, 'tipoPatrimonio')
      this.labels = Object.keys(data)
      this.data = []
      for (var i = 0; i < this.labels.length; i++) {
        var label = this.labels[i]
        this.data.push(data[label].length)
      }

      this.chart.data.labels = this.labels
      this.chart.data.datasets[0].data = this.data
      this.chart.update()
    }
  }
}
</script>